import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import { EBaseUrl } from '../models/enums/env.enum';
import { api } from '../utils';

const initialState: any = {
    regions:[],
    districts:[],
    streets:[],
    formData: {
      recipientCountry:null,
      countryWithCodes:null,
      email:'',
      firstName:'',
      lastName:'',
      phoneNumber:'',
      region:'',
      district:'',
      street:'',
      building:'',
      apartment:'',
      house:'',
    },
    recipientCountry:null
  };

  const name = 'address';

  export const getRegions = createAsyncThunk(
    `${name}/getRegions`,
    async () => {
      return api({
        method: 'GET',
        url: `${EBaseUrl.envDelivery}/${name}/getregions?clientKey=${EBaseUrl.envClientKey}`,
      });
    },
  );

  export const getDistricts = createAsyncThunk(
    `${name}/getDistricts`,
    async (regionID:number) => {
      return api({
        method: 'GET',
        url: `${EBaseUrl.envDelivery}/${name}/getdistricts?clientKey=${EBaseUrl.envClientKey}&regionID=${regionID}`,
      });
    },
  )

  export const getStreets = createAsyncThunk(
    `${name}/getStreets`,
    async (districtID:number) => {
      return api({
        method: 'GET',
        url: `${EBaseUrl.envDelivery}/${name}/getstreets?clientKey=${EBaseUrl.envClientKey}&districtID=${districtID}`,
      });
    },
  )

const addressSlice = createSlice({
    name,
    initialState,
    reducers: {
      setFormData(state,{payload}) {
        state.formData = payload;
      },
      recipientCountry(state,{payload}) {
        state.recipientCountry = payload;
      }
    },
    extraReducers: builder => {
        builder.addCase(getRegions.fulfilled, (state, {payload}) => {
            state.regions = payload;
          });
          builder.addCase(getDistricts.fulfilled, (state, {payload}) => {
            state.districts = payload;
          });
          builder.addCase(getStreets.fulfilled, (state, {payload}) => {
            state.streets = payload;
          });
    }
  });

  export const selectRegions = (state: any) => state.address.regions;

  export const selectDistricts = (state: any) => state.address.districts;

  export const selectStreets = (state: any) => state.address.streets;

  export const selectFormData = (state: any) => state.address.formData;

  export const selectRecipientCountry = (state: any) => state.address.recipientCountry;

  export const {setFormData , recipientCountry} = addressSlice.actions;
  
  export default addressSlice.reducer;